export function init() {
    const $newsPress = $('.main__body--newspress');
    if ($newsPress.length) {
        switcher($newsPress);
    }

    if (window.location.hash){
        let hash = window.location.hash;

        if (hash === '#news'){
            let selector = $newsPress.find('#news-tab');
            if (selector.length > 0){
                tab(selector);
            }
        }
        else if (hash === '#press-releases'){
            let selector = $newsPress.find('#press-tab');
            if (selector.length > 0){
                tab(selector);
            }
        }
    }
}

function tab(tab){
    const $switches = $newsPress.find('.switch__option'),
        $panels = $newsPress.find('.main__panel');

    $switches.removeClass('switch__option--active');
    tab.addClass('switch__option--active');

    $panels.removeClass('main__panel--active');
    $panels.eq(tab.index()).addClass('main__panel--active');
}

function switcher(page) {
    const $switches = page.find('.switch__option'),
        $panels = page.find('.main__panel');

    $switches.click(function () {
        const $this = $(this);

        $switches.removeClass('switch__option--active');
        $this.addClass('switch__option--active');

        $panels.removeClass('main__panel--active');
        $panels.eq($this.index()).addClass('main__panel--active');
    });
}